import Cookies from 'js-cookie'

const getHiddenNotices = () => {
  const notices = Cookies.get('seenNotices')
  let parsedNotices

  try {
    parsedNotices = JSON.parse(notices)
  } catch {
    parsedNotices = null
  }

  if (!parsedNotices && !notices) {
    return []
  }
  return parsedNotices || [notices]
}

const initialState = {
  windowWidth: 0,
  windowHeight: 0,
  scriptsLoaded: false,
  hiddenNotices: getHiddenNotices()
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'STORE_WINDOW_SIZE':
      return {
        ...state,
        windowWidth: action.width,
        windowHeight: action.height
      }
    case 'SET_SCRIPTS_LOADED':
      return {
        ...state,
        scriptsLoaded: action.scriptsLoaded
      }
    case 'SET_HIDDEN_NOTICES':
      return {
        ...state,
        hiddenNotices: action.hiddenNotices
      }
    default: {
      return state
    }
  }
}
